import SwishError from './SwishError';

export default class ServerError extends SwishError {
  isServerError() { return true; }
}
